<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure">
<div class="epigraph">
<p class="epsl"><a class="page" id="pv"></a>Malachi said to me, “We’re</p>
<p class="epsl">preaching FREEDOM, whether we</p>
<p class="epsl">like it or not.” and i understood</p>
<p class="epsl">exactly what he meant.</p>
<p class="ept">—<b>JOSEPH JARMAN</b>, <i>Black Case</i></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Steinbeck-update-0005.vue?1f038b6a